module.exports = {
    baseUrl: '/api/trader/v1/'
}